'use client'

import { Button } from '@/app/components/atoms/Button'
import { useCityContext } from '@/app/context/city'
import { ALL_LOCATIONS } from '@/app/lib/constants'
import { routes } from '@/app/lib/routing'

import { HOME_LINK_LABEL } from './ErrorPageFallback.constants'

/**
 * Botón "Ir a página de inicio" — Client Component para poder leer
 * `useCityContext()`: `ErrorPageFallback` es un Server Component y no puede
 * llamar a `getLocationState()`/`cookies()` en su propio render sin optar la
 * ruta a dynamic rendering (rompería ISR — ver el comentario de
 * `getLocationState`, `src/app/lib/geolocation/actions.ts`). Arranca en
 * `ALL_LOCATIONS` (mismo valor inicial que `CityProvider`, sin depender de la
 * cookie) y se corrige tras montar si la cookie real trae otra provincia.
 */
export function ErrorPageFallbackHomeButton() {
  const { location } = useCityContext()
  const href = location === ALL_LOCATIONS ? routes.home() : routes.homeByLocation(location)

  return (
    <Button href={href} variant="filled-inverse" shape="block" size="m">
      {HOME_LINK_LABEL}
    </Button>
  )
}
